import React, { useCallback } from "react"

import { generalPlotSettingsCleanup, getUniqueTags } from "../../resources/utils"
import { isLTPM } from "../../../../components/shared_components_registration"
import { getMatchingTrend, getTagKey } from "../../resources/utils"

const registration = {
  unknown_label: (intl) => (isLTPM ? intl.formatMessage({ id: "general.unknown" }) : "Unknown"),
}

export default function TrendRemover({
  obv_info,
  plotConfigUpdater,
  graphKey,
  observationTypes,
  tag_category,
  intl,
}) {
  const removeSeries = useCallback(() => {
    let graph = Object.assign({}, graphKey)
    let observations = Object.assign([], graph[tag_category])

    // Gets rid of all obs matching tag/smp_src for all runs
    graph[tag_category] = observations.filter((obv) => !getMatchingTrend(obv, obv_info, true))
    graph = generalPlotSettingsCleanup(graph, tag_category)

    if (getUniqueTags(graph, tag_category).length === 1) {
      const tag_name = graph?.[tag_category][0]?.tag
      graph.title = tag_name || registration.unknown_label(intl)
      graph.category = observationTypes?.[tag_name]?.type || "Unknown"
    }

    plotConfigUpdater(graph)
  }, [obv_info.tag, plotConfigUpdater, graphKey, observationTypes, tag_category, intl])

  return (
    <span
      className="fa fa-minus-circle"
      onClick={removeSeries}
      style={{ cursor: "pointer", alignItems: "center" }}
    />
  )
}
